<div class="terms-and-conditions">
	<p>
		Li e aceito os <span class="link" (click)="goTerms()">Termos e condições</span> para utilizar o BB
		Gastronomia.
	</p>
	<input type="checkbox" id="slider" [(ngModel)]="isChecked" (change)="valueChanged($event)" />
</div>
